import { jsxs as p } from "react/jsx-runtime";
import { Box as i } from "@chakra-ui/react";
import { getMetRequirementCount as r } from "./passwordInputFunctions.mjs";
const l = ({ requirements: o, ...t }) => /* @__PURE__ */ p(
  i,
  {
    role: "status",
    "aria-live": "polite",
    position: "absolute",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    border: "0px",
    overflow: "hidden",
    ...t,
    children: [
      r(o),
      " out of ",
      o == null ? void 0 : o.length,
      " requirements met."
    ]
  }
);
export {
  l as PasswordInputStatus
};
